import { render } from "./InfiniteLoadingBar.vue?vue&type=template&id=a52362d2&scoped=true"
import script from "./InfiniteLoadingBar.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingBar.vue?vue&type=script&lang=js"

import "./InfiniteLoadingBar.vue?vue&type=style&index=0&id=a52362d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a52362d2"

export default script